module.exports = __webpack_public_path__ + "img/biolink-twoimage.80aba88.jpg";